import React, { FC, useState } from 'react';
import * as S from './styles';

interface Props {
  title?: string;
  options: string[] | number[];
  selectedOption?: string | number;
  testIdPrefix?: string;
  onChange: (option: string | number) => void;
}

export const RowSelector: FC<Props> = ({
  title,
  options,
  selectedOption,
  testIdPrefix,
  onChange,
}) => {
  const [selected, setSelected] = useState(selectedOption);
  const buildTestId = (option: string | number) => {
    if (!testIdPrefix) return;
    const stateSuffix = option === selected ? '_enabled' : '';
    return `${testIdPrefix}_${option}${stateSuffix}`;
  };

  return (
    <S.Container>
      <S.Title>{title}</S.Title>
      <S.OptionsWrapper>
        {options.map(option => (
          <S.Option key={option}>
            <S.ButtonWrapper $isSelected={option === selected} data-testid={buildTestId(option)}>
              <S.Button
                buttonType="tertiary"
                onClick={() => {
                  setSelected(option);
                  onChange(option);
                }}
              >
                {option}
              </S.Button>
            </S.ButtonWrapper>
            {options[options.length - 1] !== option && <S.Divider data-testid="divider" />}
          </S.Option>
        ))}
      </S.OptionsWrapper>
    </S.Container>
  );
};
